module.exports = __webpack_public_path__ + "img/circles-animated.b14dbffd.svg";